import React from 'react';
const inputClasses = 'w-full rounded-2xl border border-lavender-200 bg-white/90 px-4 py-3.5 text-ink placeholder:text-ink-muted/70 shadow-soft transition-colors focus:border-violet-400 focus:outline-none focus:ring-4 focus:ring-violet-400/15';
interface TextFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: 'text' | 'email';
  autoComplete?: string;
  inputMode?: 'text' | 'email';
}
export function TextField({
  id,
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  autoComplete,
  inputMode
}: TextFieldProps) {
  return <div className="space-y-2" data-id="element-37" data-mp="hutcdn1hpzht">
      <label htmlFor={id} className="block text-sm font-semibold text-ink-soft" data-id="element-38" data-mp="hvuwsi4ebyc7">
        {label}
      </label>
      <input id={id} type={type} value={value} autoComplete={autoComplete} inputMode={inputMode} placeholder={placeholder} onChange={event => onChange(event.target.value)} className={inputClasses} data-id="element-39" data-mp="mupchb72h6s3" />
    </div>;
}
interface TextAreaFieldProps {
  id: string;
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
}
export function TextAreaField({
  id,
  label,
  value,
  onChange,
  placeholder,
  rows = 4
}: TextAreaFieldProps) {
  return <div className="space-y-2" data-id="element-40" data-mp="kd9aiy4oupxd">
      {label && <label htmlFor={id} className="block text-sm font-semibold text-ink-soft" data-id="element-41" data-mp="1h2gui1pnsqz6">
          {label}
        </label>}
      <textarea id={id} rows={rows} value={value} placeholder={placeholder} onChange={event => onChange(event.target.value)} className={`${inputClasses} resize-none leading-relaxed`} data-id="element-42" data-mp="1c3vvu6q22fcu" />
    </div>;
}